// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Alert,
    Button,
    TextField,
} from "@mui/material";
import { Save } from '@mui/icons-material';
import { useDifusiones } from "../../context/DifusionesContext";
import { useBody } from "../../../Body/state/BodyContext";
import { useAreas } from "../../../Areas/State/AreasContext";
import { ModalGeneral } from "../../../Componentes/ModalGeneral";
import SelectArea from "../../../Areas/Componentes/SelectArea";
import SelectListasCompartidas from "./SelectListasCompartidas";
import ItemListaEmails from "../../ItemListaEmails";
import KeyCloak from "../../../Auth/Keycloak";

export const AgregarListaModal = ({ open, onClose }) => {
    const { obtenerListas, crearLista, listas } = useDifusiones();
    const { setMessage, setSuccess } = useBody();
    const { getAreas } = useAreas();
    const [nombreLista, setNombreLista] = useState("");
    const [emails, setEmails] = useState([]);
    const [area, setArea] = useState(null);
    const [areasCompartidas, setAreasCompartidas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rootAreas, setRootAreas] = useState([]);
    const [loadingRootAreas, setLoadingRootAreas] = useState(false);

    const resetFormulario = () => {
        setNombreLista("");
        setEmails([]);
        setArea(null);
        setAreasCompartidas([]);
    };

    useEffect(() => {
        if (!open || rootAreas.length > 0) return;
        setLoadingRootAreas(true);
        getAreas()
            .then(areas => setRootAreas(areas ?? []))
            .finally(() => setLoadingRootAreas(false));
    }, [open]);

    const validarYEnviar = () => {
        if (!nombreLista || nombreLista.trim().length < 3) {
            setMessage("El nombre tiene que tener más de 3 caracteres");
            return;
        }
        if (!area) {
            setMessage("Debe seleccionar un área");
            return;
        }
        if (emails.length === 0) {
            setMessage("La lista debe poseer correos");
            return;
        }
        const duplicada = listas
            .filter((lista) => lista.propietario === area)
            .some((lista) => lista.nombre === nombreLista.trim());
        if (duplicada) {
            setMessage("La lista ya existe en esa área");
            return;
        }
        handleSubmit();
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const listaNueva = {
                nombre: nombreLista.trim(),
                propietario: area,
                integrantes: emails,
                cantidadDeCorreos: emails.length,
                usuarioCreador: KeyCloak._kc.tokenParsed?.id,
                compartidos: areasCompartidas.map(a => a.id),
            };
            await crearLista(listaNueva);
            setSuccess("Lista creada exitosamente");
            obtenerListas();
            resetFormulario();
            onClose();
        } catch (error) {
            console.error("Error al crear la lista:", error);
            setMessage("Hubo un error al crear la lista");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalGeneral
            open={open}
            onClose={() => {
                resetFormulario();
                onClose();
            }}
            titulo="Nueva Lista"
            Contenido={
                <Box component="form" onSubmit={(e) => e.preventDefault()} mt={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
                        <TextField
                            label="Nombre de la lista"
                            value={nombreLista}
                            onChange={(e) => setNombreLista(e.target.value)}
                            variant="standard"
                            inputProps={{ style: { fontSize: '1.25rem', fontWeight: 500 } }}
                            sx={{ width: 260 }}
                        />
                        <Box sx={{ mt: 1, flexShrink: 0 }}>
                            <SelectArea area={area} setArea={setArea} />
                        </Box>
                    </Box>

                    <Box sx={{ my: 5 }}>
                        <Divider sx={{ my: 2 }}>
                            <Typography variant="caption" color="text.secondary">Compartir con Áreas</Typography>
                        </Divider>
                        <SelectListasCompartidas
                            areaSeleccionada={area}
                            areasCompartidas={areasCompartidas}
                            handleAreasCompartidasChange={setAreasCompartidas}
                            rootAreas={rootAreas}
                            loadingRootAreas={loadingRootAreas}
                        />
                        <Alert severity="info" sx={{ mt: 2 }}>
                            Puede seleccionar las áreas a las cuales desea compartirles esta lista.
                        </Alert>
                    </Box>

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
                    </Divider>

                    <ItemListaEmails
                        handleEmailsChange={setEmails}
                        emails={emails}
                        isModificar={true}
                        requiereBuscador={false}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={() => { resetFormulario(); onClose(); }} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="primary"
                            startIcon={loading ? null : <Save />}
                            disabled={loading}
                            onClick={validarYEnviar}
                            type="button"
                        >
                            {loading ? 'Guardando...' : 'Guardar'}
                        </Button>
                    </Box>
                </Box>
            }
        />
    );
};
